import { ApolloError } from '@apollo/client';
/**
 * The error a query or mutation result carries when the request never reached the server — the
 * device is offline, the connection dropped, the response could not be parsed.
 *
 * For tests, and for the same reason as {@link createGraphQLOperationError}.
 */
export const createNetworkOperationError = (networkError) => new ApolloError({ networkError });
